// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file encryption/encryption_requests.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { KeyPackage, KeyPackage_Algorithm } from './encryption_model_pb';
import { file_encryption_encryption_model } from './encryption_model_pb';

/**
 * Describes the file encryption/encryption_requests.proto.
 */
export const file_encryption_encryption_requests: GenFile =
  /*@__PURE__*/
  fileDesc(
    'CiRlbmNyeXB0aW9uL2VuY3J5cHRpb25fcmVxdWVzdHMucHJvdG8SFGNvbS5nZW0uYmZmLmNvbnRyYWN0InUKEUdldENvbW1pdHNSZXF1ZXN0Eg4KBmNoYXRJZBgBIAEoAxISCgphZnRlckVwb2NoGAIgASgDEhIKBWxpbWl0GAMgASgFSACIAQESEwoGY3Vyc29yGAQgASgJSAGIAQFCCAoGX2xpbWl0QgkKB19jdXJzb3IiUgoSR2V0V2VsY29tZXNSZXF1ZXN0EhIKBWxpbWl0GAEgASgFSACIAQESEwoGY3Vyc29yGAIgASgJSAGIAQFCCAoGX2xpbWl0QgkKB19jdXJzb3IiJQoSQWNrV2VsY29tZXNSZXF1ZXN0Eg8KB2NoYXRJZHMYASADKAMikAEKGFVwbG9hZEtleVBhY2thZ2VzUmVxdWVzdBI9CglhbGdvcml0aG0YASABKA4yKi5jb20uZ2VtLmJmZi5jb250cmFjdC5LZXlQYWNrYWdlLkFsZ29yaXRobRI1CgtrZXlQYWNrYWdlcxgCIAMoCzIgLmNvbS5nZW0uYmZmLmNvbnRyYWN0LktleVBhY2thZ2UidAoiQ29uc3VtZUtleVBhY2thZ2VzQnlVc2VySWRzUmVxdWVzdBIPCgd1c2VySWRzGAEgAygDEj0KCWFsZ29yaXRobRgCIAEoDjIqLmNvbS5nZW0uYmZmLmNvbnRyYWN0LktleVBhY2thZ2UuQWxnb3JpdGhtIp4BCixDb25zdW1lS2V5UGFja2FnZXNCeVVzZXJJZEFuZERldmljZUlkUmVxdWVzdBIOCgZ1c2VySWQYASABKAMSEAoIZGV2aWNlSWQYAiABKAkSPQoJYWxnb3JpdGhtGAMgASgOMiouY29tLmdlbS5iZmYuY29udHJhY3QuS2V5UGFja2FnZS5BbGdvcml0aG0SDQoFY291bnQYBCABKAUiuAEKJ0dldEtleVBhY2thZ2VzRm9yVW50cnVzdGVkRGV2aWNlUmVxdWVzdBIQCghkZXZpY2VJZBgBIAEoCRI9CglhbGdvcml0aG0YAiABKA4yKi5jb20uZ2VtLmJmZi5jb250cmFjdC5LZXlQYWNrYWdlLkFsZ29yaXRobRISCgVsaW1pdBgDIAEoBUgAiAEBEhMKBmN1cnNvchgEIAEoCUgBiAEBQggKBl9saW1pdEIJCgdfY3Vyc29yIiMKIUNsZWFyQ3VycmVudERldmljZUUyZWVEYXRhUmVxdWVzdCIcChpHZXRLZXlQYWNrYWdlc0NvdW50UmVxdWVzdEIYChRjb20uZ2VtLmJmZi5jb250cmFjdFABYgZwcm90bzM',
    [file_encryption_encryption_model]
  );

/**
 * @generated from message com.gem.bff.contract.GetCommitsRequest
 */
export type GetCommitsRequest = Message<'com.gem.bff.contract.GetCommitsRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: int64 afterEpoch = 2;
   */
  afterEpoch: bigint;

  /**
   * @generated from field: optional int32 limit = 3;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 4;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetCommitsRequest.
 * Use `create(GetCommitsRequestSchema)` to create a new message.
 */
export const GetCommitsRequestSchema: GenMessage<GetCommitsRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 0);

/**
 * @generated from message com.gem.bff.contract.GetWelcomesRequest
 */
export type GetWelcomesRequest = Message<'com.gem.bff.contract.GetWelcomesRequest'> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;

  /**
   * @generated from field: optional string cursor = 2;
   */
  cursor?: string;
};

/**
 * Describes the message com.gem.bff.contract.GetWelcomesRequest.
 * Use `create(GetWelcomesRequestSchema)` to create a new message.
 */
export const GetWelcomesRequestSchema: GenMessage<GetWelcomesRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 1);

/**
 * @generated from message com.gem.bff.contract.AckWelcomesRequest
 */
export type AckWelcomesRequest = Message<'com.gem.bff.contract.AckWelcomesRequest'> & {
  /**
   * @generated from field: repeated int64 chatIds = 1;
   */
  chatIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.AckWelcomesRequest.
 * Use `create(AckWelcomesRequestSchema)` to create a new message.
 */
export const AckWelcomesRequestSchema: GenMessage<AckWelcomesRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 2);

/**
 * @generated from message com.gem.bff.contract.UploadKeyPackagesRequest
 */
export type UploadKeyPackagesRequest = Message<'com.gem.bff.contract.UploadKeyPackagesRequest'> & {
  /**
   * @generated from field: com.gem.bff.contract.KeyPackage.Algorithm algorithm = 1;
   */
  algorithm: KeyPackage_Algorithm;

  /**
   * @generated from field: repeated com.gem.bff.contract.KeyPackage keyPackages = 2;
   */
  keyPackages: KeyPackage[];
};

/**
 * Describes the message com.gem.bff.contract.UploadKeyPackagesRequest.
 * Use `create(UploadKeyPackagesRequestSchema)` to create a new message.
 */
export const UploadKeyPackagesRequestSchema: GenMessage<UploadKeyPackagesRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 3);

/**
 * @generated from message com.gem.bff.contract.ConsumeKeyPackagesByUserIdsRequest
 */
export type ConsumeKeyPackagesByUserIdsRequest =
  Message<'com.gem.bff.contract.ConsumeKeyPackagesByUserIdsRequest'> & {
    /**
     * @generated from field: repeated int64 userIds = 1;
     */
    userIds: bigint[];

    /**
     * @generated from field: com.gem.bff.contract.KeyPackage.Algorithm algorithm = 2;
     */
    algorithm: KeyPackage_Algorithm;
  };

/**
 * Describes the message com.gem.bff.contract.ConsumeKeyPackagesByUserIdsRequest.
 * Use `create(ConsumeKeyPackagesByUserIdsRequestSchema)` to create a new message.
 */
export const ConsumeKeyPackagesByUserIdsRequestSchema: GenMessage<ConsumeKeyPackagesByUserIdsRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 4);

/**
 * @generated from message com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdRequest
 */
export type ConsumeKeyPackagesByUserIdAndDeviceIdRequest =
  Message<'com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdRequest'> & {
    /**
     * @generated from field: int64 userId = 1;
     */
    userId: bigint;

    /**
     * @generated from field: string deviceId = 2;
     */
    deviceId: string;

    /**
     * @generated from field: com.gem.bff.contract.KeyPackage.Algorithm algorithm = 3;
     */
    algorithm: KeyPackage_Algorithm;

    /**
     * @generated from field: int32 count = 4;
     */
    count: number;
  };

/**
 * Describes the message com.gem.bff.contract.ConsumeKeyPackagesByUserIdAndDeviceIdRequest.
 * Use `create(ConsumeKeyPackagesByUserIdAndDeviceIdRequestSchema)` to create a new message.
 */
export const ConsumeKeyPackagesByUserIdAndDeviceIdRequestSchema: GenMessage<ConsumeKeyPackagesByUserIdAndDeviceIdRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 5);

/**
 * @generated from message com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceRequest
 */
export type GetKeyPackagesForUntrustedDeviceRequest =
  Message<'com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceRequest'> & {
    /**
     * @generated from field: string deviceId = 1;
     */
    deviceId: string;

    /**
     * @generated from field: com.gem.bff.contract.KeyPackage.Algorithm algorithm = 2;
     */
    algorithm: KeyPackage_Algorithm;

    /**
     * @generated from field: optional int32 limit = 3;
     */
    limit?: number;

    /**
     * @generated from field: optional string cursor = 4;
     */
    cursor?: string;
  };

/**
 * Describes the message com.gem.bff.contract.GetKeyPackagesForUntrustedDeviceRequest.
 * Use `create(GetKeyPackagesForUntrustedDeviceRequestSchema)` to create a new message.
 */
export const GetKeyPackagesForUntrustedDeviceRequestSchema: GenMessage<GetKeyPackagesForUntrustedDeviceRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 6);

/**
 * @generated from message com.gem.bff.contract.ClearCurrentDeviceE2eeDataRequest
 */
export type ClearCurrentDeviceE2eeDataRequest =
  Message<'com.gem.bff.contract.ClearCurrentDeviceE2eeDataRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.ClearCurrentDeviceE2eeDataRequest.
 * Use `create(ClearCurrentDeviceE2eeDataRequestSchema)` to create a new message.
 */
export const ClearCurrentDeviceE2eeDataRequestSchema: GenMessage<ClearCurrentDeviceE2eeDataRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 7);

/**
 * @generated from message com.gem.bff.contract.GetKeyPackagesCountRequest
 */
export type GetKeyPackagesCountRequest =
  Message<'com.gem.bff.contract.GetKeyPackagesCountRequest'> & {};

/**
 * Describes the message com.gem.bff.contract.GetKeyPackagesCountRequest.
 * Use `create(GetKeyPackagesCountRequestSchema)` to create a new message.
 */
export const GetKeyPackagesCountRequestSchema: GenMessage<GetKeyPackagesCountRequest> =
  /*@__PURE__*/
  messageDesc(file_encryption_encryption_requests, 8);
